/**
 * WifiAp Style01 - WiFi AP status
 */
import type { TraitControlProps } from './types'

export function WifiApStyle01({ state }: TraitControlProps) {
  const enabled = (state?.enabled ?? state?.status ?? state?.online) as boolean | string | undefined
  const isEnabled = enabled === true || enabled === 'enabled' || String(enabled).toLowerCase() === 'true'

  return (
    <div className="smart-home-automation-field">
      <label>WifiAp</label>
      <div className="smart-home-automation-command-row">
        <span className={`material-symbols-outlined ${isEnabled ? 'text-green-400' : 'text-slate-400'}`}>
          wifi
        </span>
        <span className="trait-wifiap-style01__value">{isEnabled ? 'Enabled' : 'Disabled'}</span>
      </div>
    </div>
  )
}
